"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = require("react");
var _HitProvider = require("../provider/HitProvider");
var _useHitPromotions = require("@deosite/api/hooks/REST/useHitPromotions");
var _LanguageProvider = require("@deosite/api/hooks/common/LanguageProvider");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useSoldCounter = function useSoldCounter() {
  var _global$__appConfig__;
  var _useHit = (0, _HitProvider.useHit)(),
    isProductPageHit = _useHit.isProductPageHit,
    sale = _useHit.sale,
    setSale = _useHit.setSale,
    isActive = _useHit.isActive,
    setIsActive = _useHit.setIsActive;
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var storeId = (_global$__appConfig__ = global.__appConfig__.storeIds) === null || _global$__appConfig__ === void 0 ? void 0 : _global$__appConfig__[language.language];
  var firstRender = (0, _react.useRef)({
    isLoading: false,
    isProductPageHit: isProductPageHit,
    intervalId: null,
    sale: sale
  });
  var getSku = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var _ref2, _hitResult$qtyForSale, _firstRender$current$, _firstRender$current$2, hitResult, saleTemporary;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (!(!isActive && isProductPageHit || firstRender.current.isLoading)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              firstRender.current.isLoading = true;
              _context.next = 6;
              return (0, _useHitPromotions.getHitPromotions)({
                storeId: storeId,
                domain: language.domain
              });
            case 6:
              hitResult = _context.sent;
              firstRender.current.isLoading = false;
              if (hitResult) {
                _context.next = 10;
                break;
              }
              throw "no hit result";
            case 10:
              saleTemporary = {
                left: (_ref2 = hitResult.maxQtyPerDay - hitResult.qtyForSale) !== null && _ref2 !== void 0 ? _ref2 : 0,
                sold: (_hitResult$qtyForSale = hitResult.qtyForSale) !== null && _hitResult$qtyForSale !== void 0 ? _hitResult$qtyForSale : 0,
                sku: hitResult.sku,
                price: hitResult.price,
                maxQtyPerClient: hitResult.qtyPerClient
              };
              if (!((hitResult.qtyForSale >= hitResult.maxQtyPerDay || (hitResult === null || hitResult === void 0 ? void 0 : hitResult.waitForNext) === true) && isActive)) {
                _context.next = 15;
                break;
              }
              setSale(saleTemporary);
              setIsActive(false);
              return _context.abrupt("return");
            case 15:
              if (!(((_firstRender$current$ = firstRender.current.sale) === null || _firstRender$current$ === void 0 ? void 0 : _firstRender$current$.left) === saleTemporary.left && ((_firstRender$current$2 = firstRender.current.sale) === null || _firstRender$current$2 === void 0 ? void 0 : _firstRender$current$2.sku) === saleTemporary.sku)) {
                _context.next = 17;
                break;
              }
              return _context.abrupt("return");
            case 17:
              firstRender.current.sale = saleTemporary;
              setSale(saleTemporary);
              _context.next = 24;
              break;
            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](0);
              console.log("Hit get current hit error:", _context.t0);
            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 21]]);
    }));
    return function getSku() {
      return _ref.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    if (sale === null) {
      getSku()["catch"](console.error);
    }
    var intervalId;
    if (isActive) {
      intervalId = setInterval(function () {
        getSku()["catch"](console.error);
      }, global.__appConfig__.currentHitRefreshSaleInterval);
    }
    firstRender.current.intervalId = intervalId;
    if (!isActive && firstRender.current.intervalId) {
      clearInterval(intervalId);
    }
    return function () {
      clearInterval(firstRender.current.intervalId);
    };
  }, [isActive]);
  return _objectSpread({}, sale);
};
var _default = useSoldCounter;
exports["default"] = _default;